
import * as fromForgot from '../../actions/login/resetPassword.actions';

export interface ForgotState {
  isAuthenticated: boolean;
  cuenta: any | null;
  errorMessage: string | null;
}

export const initialState: ForgotState = {
  isAuthenticated: false,
  cuenta: null,
  errorMessage: null
};

export function forgotReducer(state = initialState, action: fromForgot.forgotAcciones): ForgotState {
  switch (action.type) {
    case fromForgot.ForgotActionTypes.FORGOT_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        cuenta: { ...action.DatosCuenta },
        errorMessage: null
      };
    }
    case fromForgot.ForgotActionTypes.FORGOT_FAILURE: {
      return {
        ...state,
        isAuthenticated: false,
        errorMessage: { ...action.payload.error }
      };
    }
    default: {
      return state;
    }
  }
}
